/* Babiston Shopify theme: mobile menu, quote prefill, cost estimator, moving checklist. */
( function () {
	'use strict';

	var ready = function ( fn ) {
		if ( document.readyState !== 'loading' ) {
			fn();
		} else {
			document.addEventListener( 'DOMContentLoaded', fn );
		}
	};

	/* Mobile menu ------------------------------------------------------- */
	var initMenu = function () {
		var toggle = document.querySelector( '.bb-nav-toggle' );
		var nav = document.getElementById( 'bb-nav' );
		if ( ! toggle || ! nav || toggle.dataset.bound ) {
			return;
		}
		toggle.dataset.bound = '1';
		var setOpen = function ( open ) {
			toggle.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
			nav.classList.toggle( 'is-open', open );
		};
		toggle.addEventListener( 'click', function () {
			setOpen( toggle.getAttribute( 'aria-expanded' ) !== 'true' );
		} );
		document.addEventListener( 'keydown', function ( e ) {
			if ( 'Escape' === e.key && nav.classList.contains( 'is-open' ) ) {
				setOpen( false );
				toggle.focus();
			}
		} );
	};

	/* Quote form prefill from ?from=&to=&move_date=&crew=&service= ------- */
	var initPrefill = function () {
		var form = document.getElementById( 'bb-quote-form' );
		if ( ! form || ! window.URLSearchParams ) {
			return;
		}
		var params = new URLSearchParams( window.location.search );
		form.querySelectorAll( '[data-prefill]' ).forEach( function ( field ) {
			var value = params.get( field.getAttribute( 'data-prefill' ) );
			if ( value && ! field.value ) {
				field.value = value;
			}
		} );
		var service = params.get( 'service' );
		if ( service ) {
			form.querySelectorAll( '[data-prefill-service]' ).forEach( function ( box ) {
				if ( box.getAttribute( 'data-prefill-service' ).toLowerCase() === service.toLowerCase() ) {
					box.checked = true;
				}
			} );
		}
	};

	/* Cost estimator ---------------------------------------------------- */
	var initEstimators = function () {
		document.querySelectorAll( '.bb-estimator' ).forEach( function ( est ) {
			if ( est.dataset.bound ) {
				return;
			}
			est.dataset.bound = '1';
			var cfg = {};
			try {
				cfg = JSON.parse( est.getAttribute( 'data-config' ) || '{}' );
			} catch ( err ) {
				cfg = {};
			}
			// cfg.money is the store's format for 1 unit, e.g. "$1" or "1 €".
			var sample = String( cfg.money || '$1' );
			var money = function ( n ) {
				return sample.replace( /1(?:[.,]00)?/, Math.round( n ).toLocaleString( 'en-US' ) );
			};
			var val = function ( key ) {
				var el = est.querySelector( '[data-est="' + key + '"]' );
				var v = el ? parseFloat( el.value ) : 0;
				return isNaN( v ) || v < 0 ? 0 : v;
			};
			var plural = function ( n, word ) {
				return n + ' ' + word + ( n === 1 ? '' : 's' );
			};
			var out = est.querySelector( '[data-hours-out]' );
			var totalEl = est.querySelector( '[data-total]' );
			var linesEl = est.querySelector( '[data-lines]' );

			var calc = function () {
				var crewInput = est.querySelector( 'input[type="radio"]:checked' );
				var crew = crewInput ? crewInput.value : '3';
				var rate = ( cfg.rates && cfg.rates[ crew ] ) || 0;
				var h = Math.max( cfg.min || 1, val( 'hours' ) );
				var lines = [ [ crew + ' movers, ' + h + ' hr at ' + money( rate ) + '/hr', rate * h ] ];

				if ( out ) {
					out.textContent = plural( h, 'hour' );
				}
				var packers = val( 'packers' );
				var packHours = val( 'packHours' );
				if ( packers && packHours ) {
					lines.push( [ plural( packers, 'packer' ) + ', ' + packHours + ' hr', packers * packHours * cfg.packer ] );
				}
				if ( val( 'assembly' ) ) {
					lines.push( [ plural( val( 'assembly' ), 'assembly item' ) + ' (from)', val( 'assembly' ) * cfg.assembly ] );
				}
				if ( val( 'boxes' ) ) {
					lines.push( [ plural( val( 'boxes' ), 'box kit' ), val( 'boxes' ) * cfg.boxKit ] );
				}
				if ( val( 'heavy' ) ) {
					lines.push( [ plural( val( 'heavy' ), 'extra-heavy item' ) + ' (from)', val( 'heavy' ) * cfg.heavy ] );
				}

				var total = lines.reduce( function ( sum, l ) {
					return sum + l[ 1 ];
				}, 0 );
				totalEl.textContent = money( total );
				linesEl.innerHTML = '';
				lines.forEach( function ( l ) {
					var row = document.createElement( 'div' );
					var dt = document.createElement( 'dt' );
					var dd = document.createElement( 'dd' );
					dt.textContent = l[ 0 ];
					dd.textContent = money( l[ 1 ] );
					row.appendChild( dt );
					row.appendChild( dd );
					linesEl.appendChild( row );
				} );
			};
			est.addEventListener( 'input', calc );
			est.addEventListener( 'change', calc );
			calc();
		} );
	};

	/* Moving checklist -------------------------------------------------- */
	var initChecklists = function () {
		document.querySelectorAll( '[data-checklist]' ).forEach( function ( list ) {
			if ( list.dataset.bound ) {
				return;
			}
			list.dataset.bound = '1';
			var KEY = 'babiston_checklist_' + list.getAttribute( 'data-checklist' );
			var section = list.closest( 'section' ) || document;
			var boxes = list.querySelectorAll( 'input[data-task]' );
			var progress = section.querySelector( '[data-progress]' );
			var state = {};
			try {
				state = JSON.parse( window.localStorage.getItem( KEY ) || '{}' );
			} catch ( err ) {
				state = {};
			}
			var save = function () {
				try {
					window.localStorage.setItem( KEY, JSON.stringify( state ) );
				} catch ( err ) {
					/* Storage unavailable: ticks will not persist. */
				}
			};
			var update = function () {
				if ( progress ) {
					progress.textContent = list.querySelectorAll( 'input:checked' ).length + ' of ' + boxes.length + ' tasks done';
				}
			};
			boxes.forEach( function ( b ) {
				b.checked = !! state[ b.getAttribute( 'data-task' ) ];
				b.addEventListener( 'change', function () {
					state[ b.getAttribute( 'data-task' ) ] = b.checked;
					save();
					update();
				} );
			} );
			update();
			var printBtn = section.querySelector( '[data-print]' );
			if ( printBtn ) {
				printBtn.addEventListener( 'click', function () {
					window.print();
				} );
			}
			var resetBtn = section.querySelector( '[data-reset]' );
			if ( resetBtn ) {
				resetBtn.addEventListener( 'click', function () {
					state = {};
					save();
					boxes.forEach( function ( b ) {
						b.checked = false;
					} );
					update();
				} );
			}
		} );
	};

	var initAll = function () {
		initMenu();
		initPrefill();
		initEstimators();
		initChecklists();
	};

	ready( initAll );
	// Re-run when sections are edited in the Shopify theme editor.
	document.addEventListener( 'shopify:section:load', initAll );
} )();
